import { ref, storageRef } from '../config/firebase';

export function getUrl(path) {
    return ref.child(path).once('value').then((snapshot) =>
        storageRef.child(snapshot.val().name).getDownloadURL()
    );
}

export function getArchiveFiles(path, version) {
    return ref.child(path).once('value').then(async (snapshot) => {
        const archives = snapshot.val()['Archives'];
        let resultArchives = {};
        const latestVersion = snapshot.val()['latest'];
        let versionVisible = latestVersion;
        if (version !== 'latest') {
            versionVisible = version;
        }

        for (const key in archives) {
            if (archives.hasOwnProperty(key)) {
                const archive = archives[key];
                const sdk = archive.SDK;
                const version = key.replace(/-/g, '.');

                resultArchives[version] = {
                    doc: {
                        downloadUrl: await storageRef.child(archive.Documentation.name).getDownloadURL(),
                    },
                    sdk: {
                        apiName: sdk.apiName,
                        size: sdk.size,
                        updated: sdk.updated,
                        notes: sdk.notes,
                        downloadUrl: await storageRef.child(sdk.name).getDownloadURL(),
                        compatibility: sdk.compatibility,
                        version: key,
                        isSelected: key === versionVisible,
                    },
                };
            }
        }

        return resultArchives;
    });
}

export function getDataTypes() {
    return ref.child('DATA_TYPES').once('value').then(async (snapshot) => {
        const DATA_TYPES_ORDER = ['user', 'workoutresult', 'workoutpreset'];
        const dataTypes = snapshot.val() || {};

        for (const namespaceName of DATA_TYPES_ORDER) {
            const namespace = dataTypes[namespaceName];

            namespace.xmlSchemaDownloadUrl = await storageRef.child(namespace.xmlSchemaFilePath).getDownloadURL();
        }

        return DATA_TYPES_ORDER.map((namespaceName) => ({
            ...dataTypes[namespaceName],
            name: namespaceName,
        }));
    });
}



// WEBPACK FOOTER //
// ./src/firebase/storage.js